import React, { useState, useEffect } from "react";
import "./styles/App.css";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import Login from "./login";
import Home from "./home";
import { NoOrganizations, OrganizationNotFound } from "./components/organizations";
import { ConfigProvider } from "antd";
import { 
	RecurrenciesProvider, 
	EntitiesProvider, 
	CompaniesProvider, 
	GeneralAppDataProvider, 
	MassiveEmitionProvider
} from "./contexts";
import { darkTheme, lightTheme } from "./styles/ThemeStyles";
import { ClassificationsProvider } from "./contexts/ClassificationsContext";

function App() {
	const [user, setUser] = useState({});
	const [error, setError] = useState(false);
	const [darkMode, setDarkMode] = useState(false);
	const [token, setToken] = useState({});	

	const location = useLocation();

	const handleSetDarkMode = (value) => {
		setDarkMode(value);
		localStorage.setItem("darkMode", value); // Guardar 'true' o 'false' como cadena en localStorage
	};	

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const locationError = queryParams.get("error");
		const errorDescription = queryParams.get("error_description");

		if (locationError && errorDescription && errorDescription.includes("client requires organization membership")) {
			setError(true);
		}
	}, [location]);
	
	useEffect(() => {
		// Al cargar la aplicación, leer el valor almacenado en localStorage
		const storedDarkMode = localStorage.getItem("darkMode");
		if (storedDarkMode !== null) {
			// Convertir el valor almacenado a booleano y establecer darkMode
			setDarkMode(storedDarkMode === "true");
		}
	}, []);	
	

	return (
		<ConfigProvider
			theme={darkMode? darkTheme : lightTheme}>
			<GeneralAppDataProvider token={token}>
				<CompaniesProvider>
					<EntitiesProvider>
						<RecurrenciesProvider>
							<MassiveEmitionProvider> 
								<ClassificationsProvider token={token}>
									<div className="App">
										{user && Object.keys(user).length !== 0 && !error && (
											<Home
												user={user}
												token={token}
												setUser={setUser}
												setToken={setToken}
												style={{
													backgroundColor: "white",
												}}
												darkMode={darkMode}
												setDarkMode={handleSetDarkMode}
											/>
										)}
										{user && Object.keys(user).length === 0 && !error && (
											<Login
												setUser={setUser}
												setToken={setToken}
											/>
										)}
										{ error && <NoOrganizations />}
										{ !user && <OrganizationNotFound />}
									</div>
								</ClassificationsProvider>
							</MassiveEmitionProvider>
						</RecurrenciesProvider>
					</EntitiesProvider>
				</CompaniesProvider>
			</GeneralAppDataProvider>
		</ConfigProvider>
	);
}

function WrappedApp() {
	return (
		<Router>
			<App />
		</Router>
	);
}

export default WrappedApp;
